import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchAppSetting, updateAppSetting } from "actions/appSetting";
import { fetchTags } from "actions/tag";
import {
  uploadImage,
  setUploadedImagePreview,
  removeUploadedImage
} from "actions/image";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import dateUtil from "utils/date";

import Form from "pages/AppSettings/Form";

class AppSettingEdit extends Component {
  componentWillUnmount() {
    this.props.removeUploadedImage("cover");
    this.props.removeUploadedImage("logo");
  }

  componentDidMount() {
    const { activeCompany, match, fetchAppSetting } = this.props;
    const company_url = activeCompany.url;
    const id = match.params.appSettingId;
    fetchAppSetting(id, { company_url });
  }

  shapedDefaultValuesStructure() {
    const {
      expired_at,
      released_at,
      tags,
      attachments,
      ...rest
    } = this.props.appSetting.data;
    return Object.assign(
      {},
      {
        ...rest,
        released_at: dateUtil.phpFormatToJS(released_at),
        expired_at: dateUtil.phpFormatToJS(expired_at),
        attachments: attachments,
        tags: tags ? tags.map(({ name }) => name) : undefined
      }
    );
  }

  updateAppSetting(id, data) {
    const {
      toggleNotification,
      activeCompany,
      toggleFullPageSpinner,
      updateAppSetting,
      history
    } = this.props;

    toggleFullPageSpinner(true);

    updateAppSetting(id, data)
      .then(() => {
        toggleNotification(true, {
          message: "Updated AppSetting Success",
          infoClassName: "is-success"
        });
        history.push(`/${activeCompany.url}/app-settings`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const { activeCompany, match } = this.props;
    const id = match.params.appSettingId;

    data = Object.assign({}, data, { company_url: activeCompany.url });
    this.updateAppSetting(id, data);
  };

  render() {
    const {
      uploadedImagesPreview,
      uploadedImagesPercentage,
      uploadedImages,
      removeUploadedImage,
      uploadImage,
      setUploadedImagePreview,
      appSetting,
      tags,
      fetchTags,
      activeCompany
    } = this.props;

    if (appSetting.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        uploadImage={uploadImage}
        uploadedImages={uploadedImages}
        setUploadedImagePreview={setUploadedImagePreview}
        removeUploadedImage={removeUploadedImage}
        uploadedImagesPreview={uploadedImagesPreview}
        uploadedImagesPercentage={uploadedImagesPercentage}
        defaultValues={defaultValues}
        tags={tags}
        fetchTags={fetchTags}
        activeCompany={activeCompany}
      />
    );
  }
}

const mapStateToProps = ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview,
  appSetting,
  tags
}) => ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview,
  appSetting,
  tags
});

export default connect(mapStateToProps, {
  fetchAppSetting,
  updateAppSetting,
  uploadImage,
  removeUploadedImage,
  setUploadedImagePreview,
  toggleFullPageSpinner,
  toggleNotification,
  fetchTags
})(AppSettingEdit);
